import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";

// export const createUnit = (data) =>
//   axios.post(
//     `${ApiLink.API_URL}ArticleUnits/newUnit`,
//     data,
//     { headers: authHeader() }
//   );

// export const updateUnit = (data) => {
//   // data duhet të ketë UnitID, UnitName, IsActive
//   return axios.put(`${ApiLink.API_URL}ArticleUnits/editUnit`, data, {
//     headers: authHeader(),
//   });
// };


// export const deleteUnit = (deleteItemId) =>
//   axios.delete(
//     `${ApiLink.API_URL}articleunits/${deleteItemId}`,
//     { headers: authHeader() }
//   );
// UnitService.js
export const createUnit = async (data) => {
  const res = await axios.post(`${ApiLink.API_URL}ArticleUnits/newUnit`, data, {
    headers: authHeader(),
  });
  if (!res.data || res.data.toString().toLowerCase().includes("error")) {
    throw new Error(res.data || "Insert failed");
  }
  return res.data;
};

export const updateUnit = async (data) => {
  const res = await axios.put(`${ApiLink.API_URL}ArticleUnits/editUnit`, data, {
    headers: authHeader(),
  });
  if (!res.data || res.data.toString().toLowerCase().includes("error")) {
    throw new Error(res.data || "Update failed");
  }
  return res.data;
};

export const deleteUnit = async (id) => {
  const res = await axios.delete(`${ApiLink.API_URL}ArticleUnits/${id}`, {
    headers: authHeader(),
  });

  // Kontrollo suksesin nga backend
  if (!res.data.success) {
    throw new Error(res.data.message || "Delete failed");
  }

  return res.data.message;
};

